const DeclineRequestStatusEnum = {
    declineRequested: 1,
};
export default DeclineRequestStatusEnum